import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Modal } from 'antd';

var _excluded = ["centered", "className", "title", "footer", "isModalVisible", "handleModalCancel"];
var DmModal = function DmModal(_ref) {
  var _ref$centered = _ref.centered,
    centered = _ref$centered === void 0 ? true : _ref$centered,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    _ref$footer = _ref.footer,
    footer = _ref$footer === void 0 ? null : _ref$footer,
    isModalVisible = _ref.isModalVisible,
    handleModalCancel = _ref.handleModalCancel,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Modal, _extends({
    centered: centered,
    title: title,
    className: "dm-modal ".concat(className),
    footer: footer,
    visible: isModalVisible,
    onCancel: handleModalCancel
  }, props), props.children);
};
DmModal.defaultProps = {
  isModalVisible: false
};

export { DmModal };
